import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtroSearch',
  standalone: true,
})
export class FiltroSearchPipe implements PipeTransform {
  transform(elementos: any[], ...args: unknown[]): unknown {
    return elementos.slice(0, 100);
  }
}
